module.exports = __webpack_public_path__ + "static/media/homeImage.fd969364.jpg";